var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeepSea(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#727831",
    fillRule: "nonzero",
    stroke: "#727831",
    strokeWidth: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.125 30.25a.625.625 0 0 1-.625-.625v-1.25a.625.625 0 0 1 1.25 0v1.25c0 .345-.28.625-.625.625zM35.25 30.25a.625.625 0 0 1-.625-.625v-1.25a.625.625 0 0 1 1.25 0v1.25c0 .345-.28.625-.625.625zM38.375 30.25a.625.625 0 0 1-.625-.625v-1.25a.625.625 0 0 1 1.25 0v1.25c0 .345-.28.625-.625.625z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.375 34h-32.5a.625.625 0 0 1-.509-.262l-6.25-8.75A.625.625 0 0 1 4.626 24h35.994A3.385 3.385 0 0 1 44 27.38v5.994c0 .345-.28.625-.625.625zm-32.178-1.25H42.75V27.38a2.134 2.134 0 0 0-2.131-2.131H5.84l5.357 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.842 34H10.553l-4.46-6.25h5.957c3.24 0 6.116 1.295 7.156 3.222L20.842 34zm-9.645-1.25h7.549l-.64-1.184C17.291 30.055 14.8 29 12.05 29H8.52l2.677 3.75zM22.75 30.25a.625.625 0 0 1-.625-.625v-1.25a.625.625 0 0 1 1.25 0v1.25c0 .345-.28.625-.625.625zM25.875 30.25a.625.625 0 0 1-.625-.625v-1.25a.625.625 0 0 1 1.25 0v1.25c0 .345-.28.625-.625.625z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.875 30.25a.625.625 0 0 1-.625-.625v-1.25a.625.625 0 0 1 1.25 0v1.25c0 .345-.28.625-.625.625zM29 30.25a.625.625 0 0 1-.625-.625v-1.25a.625.625 0 0 1 1.25 0v1.25c0 .345-.28.625-.625.625zM38.375 25.25H9.625a.624.624 0 0 1-.585-.845l1.875-5A.625.625 0 0 1 11.5 19h24.375c.237 0 .453.134.56.346l2.5 5a.626.626 0 0 1-.56.904zM10.527 24h26.837l-1.875-3.75H11.933L10.527 24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.75 20.25h-17.5a.625.625 0 0 1-.61-.764l1.142-5a.625.625 0 0 1 .61-.486h14.836c.275 0 .518.18.598.443l1.522 5a.625.625 0 0 1-.598.807zM16.034 19h15.872l-1.14-3.75H16.89L16.034 19zM32.125 22.75H15.25a.625.625 0 0 1 0-1.25h16.875a.625.625 0 0 1 0 1.25z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeepSea);
export default __webpack_public_path__ + "static/media/deep-sea.0f156d82601ddb0e9cd921abe4c87219.svg";
export { ForwardRef as ReactComponent };